import { fetchAllRunnedTask, fetchRunningTask } from '../services/trackerService';

export const sprintStatusColor = {
  pending: '#FBC02D',
  'in-progress': '#0288D1',
  completed: '#2E7D32',
};
export function calculateRiskLevel(difference) {
  if (difference <= 10) return 'Low';
  if (difference <= 20) return 'Medium';
  return 'High';
}
export function calculateProjectHealth(project, sprints) {
  const now = new Date();
  if (project.health) {
    return { health: project.health, risk: project.risk };
  }
  // 1. Completed
  if (project.actualEndDate && new Date(project.actualEndDate) <= now) {
    return { health: 'Completed', risk: 'Low' };
  }

  // 2. Not started
  if (!project.actualStartDate) {
    return { health: 'Not Started', risk: 'Low' };
  }

  // 3. On Hold
  if (project.holdStartDate || project.holdEndDate) {
    return { health: 'On Hold', risk: 'Medium' };
  }
  const startDate = new Date(project.startDate);
  const endDate = new Date(project.endDate);

  const totalDays = (endDate - startDate) / (1000 * 60 * 60 * 24);
  const daysPassed = (now - startDate) / (1000 * 60 * 60 * 24);

  const timeProgress = Math.min(Math.max((daysPassed / totalDays) * 100, 0), 100);

  const totalSprints = sprints.length;
  const completedSprints = sprints.filter((s) => s.status?.toLowerCase() === 'completed').length;

  const workProgress = totalSprints > 0 ? (completedSprints / totalSprints) * 100 : 0;

  const difference = timeProgress - workProgress;

  let health = '';
  if (difference <= 10) health = 'On Track';
  else if (difference <= 25) health = 'At Risk';
  else health = 'Delayed';

  let risk = '';
  if (difference <= 10) risk = 'Low';
  else if (difference <= 20) risk = 'Medium';
  else risk = 'High';
  return { health, risk };
}
export function getCurrentSprint(sprints = []) {
  const inProgress = sprints.filter((s) => s.status?.toLowerCase() === 'in-progress');

  if (inProgress.length === 0) return null;

  // return latest sprint (based on plannedStartDate)
  return inProgress.sort((a, b) => new Date(b.plannedStartDate) - new Date(a.plannedStartDate))[0];
}

export function getPreviousSprint(sprints = []) {
  const completed = sprints.filter((s) => s.status?.toLowerCase() === 'completed');
  if (completed.length === 0) return null;
  return completed[completed.length - 1].name;
}

export async function getLatestTaskInCurrentSprint(sprints = []) {
  const currentSprint = getCurrentSprint(sprints);

  if (!currentSprint?.tasks?.length) {
    return null;
  }

  const trackerResults = await Promise.all(currentSprint.tasks.map((task) => fetchAllRunnedTask(task.id)));

  const trackers = trackerResults.flatMap((res) => res?.data?.data || []);

  if (!trackers.length) {
    return null;
  }

  const runningTrackers = trackers.filter((t) => t.stopTime === null);

  let selectedTracker;

  if (runningTrackers.length > 0) {
    // Latest running tracker by start time
    selectedTracker = runningTrackers.sort((a, b) => new Date(b.startTime) - new Date(a.startTime))[0];
  } else {
    // All stopped → latest stopped tracker by stop time
    selectedTracker = trackers.sort((a, b) => new Date(b.stopTime) - new Date(a.stopTime))[0];
  }

  return currentSprint.tasks.find((task) => task.id === selectedTracker.taskId) || null;
}

export function truncateText(text = '', length = 15) {
  if (!text) return '';
  return text.length > length ? `${text.substring(0, length)}...` : text;
}
